import "./UpdatePopup.scss";
import { useEffect } from "react";
import X from "../../assets/images/X.svg";

function UpdatePopup({ Popupshow, main, popupTimer = 15000, popupStyle = "" }) {
  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => {
      Popupshow(false);
    }, popupTimer);
  });
  return (
    <div className="updatePopupLayout">
      <div
        className={`loading-bar ${popupStyle === "error" ? `loading-bar-error` : `loading-bar-normal`}`}
      />
      <img
        src={X}
        alt="exit"
        className="updatePopupLayout__exit"
        onClick={() => {
          Popupshow(false);
        }}
      />
      <p className="updatePopupLayout__maintext">{main}</p>
    </div>
  );
}

export default UpdatePopup;
